import React from 'react';
import * as styles from './section.module.scss';

interface ISectionProps {
  title?: string;
  classNameChildren?: string;
  children: React.ReactNode;
  className?: string;
  hidden?: boolean;
}

export const Section = ({
  title,
  classNameChildren,
  children,
  className,
  hidden = false,
}: ISectionProps) => (
  <section className={`${className ?? ''} ${styles.wrapper} ${hidden ? styles.hidden : ''}`}>
    <h3 className={styles.title}>{title}</h3>
    <div className={classNameChildren}>{children}</div>
  </section>
);
